import {type Hub, Tag} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {Sync} from '@client/sync'
import {TableUserInfo} from '@components/common/base/users-table/types'
import {UsersTableUtil} from '@components/common/users-table/users-table-util'
import {PageService} from '@extensions/page-service'
import {canAssignUser} from '@extensions/sticker/views-web/user-view'
import {UserAccess} from '@extensions/user-access'

export const useUsersList = (
  hub: Hub | undefined,
  sticker: Tag
): TableUserInfo[] => {
  const box = Sync.get(sticker)
  const users = box.getAllUsers(false)
  const proj = PageService.getCurrentProject()
  const calculatedHierarchy = DepartmentsClient.getHierarchy(box)
  return users
    .filter(u => u && canAssignUser(hub, u.id, calculatedHierarchy))
    .map(u => UsersTableUtil.convertUser(box, u, proj))
}

export const useCanInvite = (): boolean => {
  const proj = PageService.getCurrentProject()
  return UserAccess.canChangeUserInProject(proj)
}

export const useIsOnBoard = (sticker: Tag): boolean => {
  const board = PageService.getCurrentBoard()
  return !board || board.companyId !== sticker.companyId
}
